import React from 'react';
import EntityDetailDialog from './EntityDetailDialog';
import { AssetIcon } from '../assets';
import './metric-links-dialog.css';

export default function MetricLinksDialog({
  isOpen, onClose, title, subtitle, iconKey, itemIconKey = iconKey,
  items, getItemLabel, getItemDescription, getItemDetail, itemActionLabel,
  onSelect, emptyMessage, statusMessage, className = '',
}) {
  return (
    <EntityDetailDialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      avatarLabel={<AssetIcon name={iconKey} size={32} />}
      className={`metric-links-dialog ${className}`.trim()}
    >
      {statusMessage ? <p role="status">{statusMessage}</p> : (
        <>
          <div className="metric-links-dialog__grid">
            {items.map((item) => {
              const label = getItemLabel(item);
              const description = getItemDescription?.(item);
              const detail = getItemDetail?.(item);
              return (
                <button type="button" key={item.id} className="metric-links-dialog__link"
                  aria-label={`${itemActionLabel}: ${label}`} onClick={() => onSelect(item)}>
                  <AssetIcon name={itemIconKey} size={32} aria-hidden="true" />
                  <span className="metric-links-dialog__copy">
                    <strong>{label}</strong>
                    {description ? <span>{description}</span> : null}
                    {detail ? <small>{detail}</small> : null}
                  </span>
                </button>
              );
            })}
          </div>
          {!items.length ? <p role="status">{emptyMessage}</p> : null}
        </>
      )}
    </EntityDetailDialog>
  );
}
